"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var limiter_1 = require("limiter");
var promisify_1 = require("./promisify");
var semaphore_1 = require("./semaphore");
/**
 * A Semaphore which uses the 'limiter' npm package to provide rate limiting.
 * 'limiter' must be installed separately as an optional dependency
 */
var Limiter = /** @class */ (function (_super) {
    __extends(Limiter, _super);
    function Limiter(config) {
        var _this = _super.call(this) || this;
        _this.config = Object.assign({
            tokens: Infinity
        }, config);
        _this._limiter = new limiter_1.RateLimiter(_this.config.tokensPerInterval, _this.config.interval);
        return _this;
    }
    /**
     * Gets a snapshot of the current state of the semaphore.
     * @returns the current number of inflight requests, and the current queue size.
     */
    Limiter.prototype.stats = function () {
        return __assign({}, _super.prototype.stats.call(this), { availableTokens: this._limiter.getTokensRemaining() });
    };
    /**
     * Locks the semaphore, running or enqueuing the given task.  The semaphore is
     * not unlocked until the task completes.  The task should perform the minimum
     * required work and then return a value.  For example, connecting to a remote
     * API and returning the response body for further processing.
     *
     * The task can either be an async function returning a promise, or a function
     * that accepts a callback as the first parameter.
     *
     * @param action An action to be run when the number of inflight tasks is below the limit.
     * @returns A promise that completes when the action completes, returning the result
     *  of the action.
     */
    Limiter.prototype.lock = function (action, rw) {
        var _this = this;
        if (rw === void 0) { rw = 'read'; }
        return _super.prototype.lock.call(this, function (lock, taskCallback) {
            _this._limiter.removeTokens(1, function () {
                promisify_1.callbackify(function (cb) { return action(lock, cb); }, taskCallback);
            });
        }, rw);
    };
    return Limiter;
}(semaphore_1.Semaphore));
exports.Limiter = Limiter;
//# sourceMappingURL=limiter.js.map